import React, { useState } from "react";
import { Box, Typography, Dialog, Skeleton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getPortfolioApi } from "@/util/api/portfolio";
import AppartmentCard from "../../components/portfolio/appartmentCard";
import PortfolioPopup from "../../components/home/portfolioPopup";
import { appResponse, pxToRem } from "@/util";
import { IProperties } from "@/util/types/property";
import { ExtendedPortfolio } from "@/util/types/portfolio";

import { makeStyles } from "tss-react/mui";

const FeaturedList = () => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { classes } = styles();
  const { data, isLoading, isError, error } = useQuery<
    appResponse<ExtendedPortfolio[]>
  >({
    queryKey: ["portfolio"],
    queryFn: () => getPortfolioApi({ page: 1, limit: 2 }),
    select: (data): appResponse<ExtendedPortfolio[]> => ({
      ...data,
      payload: data.payload.map((item) => {
        const property =
          typeof item.property === "object" && item.property !== null
            ? (item.property as Partial<IProperties>)
            : {};

        return {
          ...item,
          media: Array.isArray(property.media)
            ? property.media.map((m) =>
                typeof m === "string"
                  ? { url: m }
                  : { url: m?.url || "/placeholder.jpg" }
              )
            : [],
          name: `${property.name || ""} 
          `,
          city: property.city || "",
          state: property.state || "",
          // propertyType: property.propertyType || "",
          details: `${property.propertyType || "N/A"} | Completed in ${
            property.yearbuilt || "N/A"
          }`,
          description: property.description || "",
          location:
            typeof property.location === "string" ? property.location : "",
        };
      }),
    }),
  });

  const handleClose = () => setSelectedId(null);

  if (isError) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <Typography color="error">Error: {error.message}</Typography>
      </Box>
    );
  }

  if (!data?.payload?.length && !isLoading) {
    return (
      <Box
        sx={(theme) => ({
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: theme.spacing(4),
          position: "relative",
        })}
      >
        <Typography>No portfolio available.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={(theme) => ({
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: theme.spacing(4),
          position: "relative",
        })}
      >
        {isLoading ? (
          <Box className={classes.sub}>
            {[1, 2].map((apartment, i) => (
              <Skeleton key={i} className={classes.skel} />
            ))}
          </Box>
        ) : (
          data &&
          data.payload.map((item, index) => (
            <Box
              key={item._id || index}
              onClick={() => setSelectedId(item._id)}
              sx={{ cursor: "pointer" }}
            >
              <AppartmentCard
                apartment={{
                  image: item.media?.[0]?.url || "/placeholder.jpg",
                  name: item.name,
                  city: item.city,
                  // location: item.location,
                  //propertyType: item.propertyType,
                  details: item.details,
                  description: item.description,
                }}
              />
            </Box>
          ))
        )}
      </Box>

      <Dialog open={!!selectedId} onClose={handleClose} maxWidth="md" fullWidth>
        {selectedId && (
          <PortfolioPopup handleClose={handleClose} id={selectedId} />
        )}
      </Dialog>
    </>
  );
};

export default FeaturedList;

const styles = makeStyles()((theme) => ({
  sub: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(3),
  },
  skel: {
    height: pxToRem(400),
    display: "flex",
  },
}));
